// src/App.jsx
// ✅ App.jsx نظيف — مع Dark Mode Toggle
import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider, useAuth } from './features/auth/context/AuthContext';
import AppRoutes    from './routes';
import Sidebar      from './shared/components/layout/Sidebar';
import ThemeToggle  from './shared/components/ui/ThemeToggle';
import './App.css';

/* ─── المحتوى الداخلي ─────────────────────────────────────── */
function AppContent() {
  const { loggedInUser, logout, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) {
    return (
      <div style={{
        display:        'flex',
        justifyContent: 'center',
        alignItems:     'center',
        height:         '100vh',
        fontSize:       '1rem',
        color:          'var(--text-muted)',
        background:     'var(--bg-app)',
      }}>
        جاري التحقق من تسجيل الدخول...
      </div>
    );
  }

  return (
    <div className="App">

      {/* ── Header ── */}
      {loggedInUser && (
        <header className="app-header">
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(true)}
            aria-label="فتح القائمة"
            type="button"
          >
            ☰
          </button>

          {/* يملأ المساحة الوسطى */}
          <div style={{ flex: 1 }} />

          {/* زر تبديل الثيم */}
          <ThemeToggle />
        </header>
      )}

      {/* ── Overlay + Sidebar ── */}
      {loggedInUser && (
        <>
          {sidebarOpen && (
            <div
              className="overlay"
              onClick={() => setSidebarOpen(false)}
            />
          )}
          <Sidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
            user={loggedInUser}
            onLogout={logout}
          />
        </>
      )}

      {/* ── المحتوى ── */}
      <main className={loggedInUser ? 'main-content' : ''}>
        <AppRoutes />
      </main>
    </div>
  );
}

/* ─── الجذر ───────────────────────────────────────────────── */
function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;